import { Icon, IconButton, Menu } from "@mui/material";
import React, { useCallback, useState } from "react";
import ProductMenuItems from "../ProductMenuItems/ProductMenuItems";

export default function ProductActionsCell({ value, row }: { value: string; row: any }) {
  const [anchorElement, setAnchorElement] = useState<Element | null>(null);

  const closeMenu = useCallback(() => {
    setAnchorElement(null);
  }, []);

  const productTypeId = row.original?.organizationProductType?.id;

  return (
    <>
      <Menu
        anchorEl={anchorElement}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={Boolean(anchorElement)}
        onClose={closeMenu}
        keepMounted
      >
        <ProductMenuItems id={value} productTypeId={productTypeId} closeMenu={closeMenu} />
      </Menu>
      <IconButton
        aria-label={`Actions for ${row.original?.name || "product"}`}
        aria-haspopup="menu"
        aria-expanded={Boolean(anchorElement)}
        size="small"
        sx={{ display: "flex", mx: "auto" }}
        onClick={(event) => setAnchorElement(event.currentTarget)}
      >
        <Icon>more_vert</Icon>
      </IconButton>
    </>
  );
}
